import styled from "styled-components";

export const Container = styled.div`
    margin-top: 100px;
    margin-left: auto;
    margin-right: auto;
    max-width: 500px;
    font-size: 32px;
    text-align: center;
`;